import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import FileUpload from './FileUpload';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import React, { useEffect, useState } from 'react';
import ApiService from '../../../services/ApiService';
import moment from 'moment';
import { debounce } from 'lodash';

export const ActionHeader = ({
  actionHeaderState,
  onHeaderSet,
  onAutoFillRekomendasi,
  action,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataRegion, setDataRegion] = useState([]);
  const [regionId, setRegionId] = useState(0);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [isAuto, setIsAuto] = useState(false);
  const [dataInvestigasi, setDataInvestigasi] = useState([]);
  const [actionHeader, setActionHeader] = actionHeaderState;

  const [users, setUsers] = useState([]);
  const [dataRekomendasi, setDataRekomendasi] = useState([]);

  const getUsers = async (val) => {
    setIsLoading(true);
    try {
      await ApiService.getListUserAdmin(val).then((res) => {
        if (res.data.isOk) {
          setUsers(res.data.payload);
        } else {
          alert(res.data.message);
          setTimeout(() => {
            // router("/");
          }, 500);
        }
        setIsLoading(false);
      });
    } catch (error) {
      setIsLoading(false);
      alert('The Error was occured', error);
      setTimeout(() => {
        // router("/");
      }, 500);
    }
  };

  const getDataRegion = () => {
    setIsLoading(true);
    ApiService.getMsRegional().then((res) => {
      const result = res.data.payload;
      setDataRegion(result);
      setIsLoading(false);
    });
  };

  const getDataLokasi = () => {
    if (!regionId) return;

    setIsLoading(true);
    ApiService.getMsLokasi(regionId).then((res) => {
      const result = res.data.payload;
      setDataLokasi(result);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    getDataLokasi();
  }, [regionId]);

  const getDataInvestigasi = (nomorLapInvest = null) => {
    setIsLoading(true);
    ApiService.getListLapInvestigasi({
      noInvestigasi: nomorLapInvest,
      page: 1,
      itemPerPage: 5,
    }).then(({ data }) => {
      setDataInvestigasi(data.payload.data);
      setIsLoading(false);
    });
  };

  const getRekomendasiInvestigasi = (lapInvestigasiId) => {
    setIsLoading(true);

    ApiService.getRekomendasiInvestigasi(lapInvestigasiId).then(({ data }) => {
      if (!data.isOk) {
        setDataRekomendasi([]);
        onAutoFillRekomendasi([], data?.message);
        setIsLoading(false);
        return;
      }
      const result = data.payload.listRekomendasi;
      setDataRekomendasi(result);
      onAutoFillRekomendasi(result);
      setIsLoading(false);
    });
  };

  const onChangeRegion = (event, value) => {
    if (!value) {
      setRegionId(0);
      return;
    }
    setRegionId(value.id);
    setDataLokasi([]);
    setActionHeader((prevHeader) => ({
      ...prevHeader,
      idRegion: value.id,
      idLokasi: 0,
      namaLokasi: '',
    }));
  };

  const onChangeLokasi = (event, value) => {
    if (!value) {
      return;
    }
    setActionHeader({
      ...actionHeader,
      idLokasi: value.id,
      namaLokasi: value.name,
    });
  };

  const chooseInvestigasi = (e, val) => {
    if (!val == null || val != undefined) {
      setActionHeader({ ...val, judul: val.nomorLapInvest });
      setRegionId(val.regionId);
      if (isAuto && val.lapInvestigasiId) {
        setActionHeader({
          idLapInvestigasi: val.lapInvestigasiId,
          tglDisahkan: val.submitedDate,
          judul: val.nomorLapInvest,
          idRegion: val.regionId,
          idLokasi: val.lokasiId,
          namaLokasi: val.lokasi,
          createdBy: '',
          saveAs: '',
          idUpload: 0,
          approverEmail: '',
          approverDisplayName: '',
          approverJabatan: '',
          ...val,
        });
        getRekomendasiInvestigasi(val.lapInvestigasiId);
      }
    } else {
      setActionHeader(null);
    }
  };

  const onChangeJudul = debounce((event) => {
    setActionHeader({
      ...actionHeader,
      judul: event.target.value,
    });
  }, 300);

  const handleKeyDown = async (e) => {
    setIsLoading(true);
    if (e.key === 'Enter' || e.key == ' ') {
      await getDataInvestigasi(e.target.value);
    }
    setIsLoading(false);
  };

  const handleKeyDownApprover = async (e) => {
    setIsLoading(true);
    if ((e.key == 'Enter' || e.key == ' ') && e.target.value.length >= 5) {
      await getUsers(e.target.value);
    }
    setIsLoading(false);
  };

  const handleSetHeader = (e) => {
    onHeaderSet({ ...actionHeader });
  };

  const handleUploadedFile = ({ id, fileName, url }) => {
    setActionHeader({
      ...actionHeader,
      idUpload: id,
      fileUploadOriginalName: fileName,
      fileUploadPath: url,
    });
  };

  const handleApproverChange = (e, value) => {
    setActionHeader({
      ...actionHeader,
      approverEmail: value.email,
      approverDisplayName: value.namalengkap,
      approverJabatan: value.jabatan === '' ? '-' : value.jabatan,
    });
  };

  const handleTanggalDisahkan = (date) => {
    setActionHeader((prevActionHeader) => ({
      ...prevActionHeader,
      tglDisahkan: date.toString(),
    }));
  };

  useEffect(() => {
    setIsAuto(props.isAuto);
    if (actionHeader) {
      setActionHeader({ ...actionHeader });
    }
  }, [props.isAuto]);

  useEffect(() => {
    getDataRegion();
    getDataLokasi();
    getDataInvestigasi();

    if (actionHeader) {
      setActionHeader({ ...actionHeader });
    }
  }, []);

  return (
    <Grid container alignItems="center">
      <Grid item xs={12}>
        <Typography variant="h6" marginTop={3}>
          Header
        </Typography>
      </Grid>
      <Grid item xs={12} marginBottom={3} marginTop={4}>
        <FormControl fullWidth>
          {isAuto ? (
            <Autocomplete
              loading={isLoading}
              name="idNamaPegawai"
              onChange={(e, value) => chooseInvestigasi(e, value)}
              onKeyDown={handleKeyDown}
              required
              getOptionLabel={(option) => option.nomorLapInvest}
              options={dataInvestigasi.map((item) => ({
                ...item,
                name: item.nomorLapInvest,
                value: item.nomorLapInvest,
              }))}
              renderInput={(params) => <TextField {...params} label="Judul" />}
              getOptionSelected={(option, value) => option.id === value.id}
              disabled={!(actionHeader?.id === undefined)}
            />
          ) : (
            <TextField
              label="Judul"
              variant="outlined"
              fullWidth
              onChange={onChangeJudul}
              defaultValue={actionHeader?.judul}
            />
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} marginBottom={3}>
        <FormControl fullWidth>
          {isAuto ? (
            <TextField
              label="Regional"
              variant="outlined"
              fullWidth
              value={actionHeader?.region || ''}
              disabled={!(actionHeader?.id === undefined)}
            />
          ) : (
            <Autocomplete
              name="idRegional"
              onChange={onChangeRegion}
              required
              getOptionLabel={(option) => option.name || ''}
              options={dataRegion}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Regional"
                  value={actionHeader?.namaRegion}
                />
              )}
              getOptionSelected={(option, value) => option.name === value.name}
              defaultValue={{ name: actionHeader?.namaRegion }}
              disabled={!(actionHeader?.id === undefined)}
            />
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} marginBottom={3}>
        <FormControl fullWidth>
          {isAuto ? (
            <TextField
              label="Lokasi"
              variant="outlined"
              fullWidth
              value={actionHeader?.lokasi || ''}
              disabled={!(actionHeader?.id === undefined)}
            />
          ) : (
            <Autocomplete
              loading={isLoading}
              name="idLokasi"
              onChange={onChangeLokasi}
              required
              getOptionLabel={(option) => option.name || ''}
              options={dataLokasi}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Lokasi"
                  value={actionHeader?.namaLokasi || ''}
                />
              )}
              getOptionSelected={(option, value) => option.name === value.name}
              defaultValue={{ name: actionHeader?.namaLokasi }}
              disabled={!(actionHeader?.id === undefined)}
            />
          )}
        </FormControl>
      </Grid>
      {isAuto ? (
        <></>
      ) : (
        <Grid item xs={12} marginBottom={3}>
          <FormControl fullWidth>
            <FileUpload
              onFileUploaded={handleUploadedFile}
              defaultFile={{
                id: actionHeader?.idUpload,
                name: actionHeader?.fileUploadOriginalName,
                path: actionHeader?.fileUploadPath,
              }}
              onFileDeleted={() => {
                setActionHeader({
                  ...actionHeader,
                  idUpload: null,
                  fileUploadOriginalName: null,
                  fileUploadPath: null,
                });
              }}
              disabled={
                (actionHeader?.id &&
                  actionHeader.statusHeaderName === 'Completed') ||
                actionHeader?.statusHeaderName === 'Closed'
              }
            />
          </FormControl>
        </Grid>
      )}
      <Grid item xs={12} marginBottom={3}>
        <FormControl fullWidth>
          {isAuto ? (
            <TextField
              label="Tanggal Disahkan"
              variant="outlined"
              fullWidth
              value={
                moment(actionHeader?.submitedDate).format('DD-MMMM-YYYY') || ''
              }
              disabled={!(actionHeader?.id === undefined)}
            />
          ) : (
            <DesktopDatePicker
              label="Tanggal Disahkan"
              variant="standard"
              fullWidth
              inputFormat="DD-MMMM-YYYY"
              value={actionHeader?.tglDisahkan}
              onChange={handleTanggalDisahkan}
              maxDate={new Date()}
              renderInput={(params) => <TextField {...params} />}
              disableMaskedInput
              disabled={!(actionHeader?.id === undefined)}
            />
          )}
        </FormControl>
      </Grid>
      <Grid item xs={12} marginBottom={3}>
        <FormControl fullWidth>
          <Autocomplete
            loading={isLoading}
            name="approverEmail"
            onChange={handleApproverChange}
            onKeyDown={handleKeyDownApprover}
            required
            getOptionLabel={(option) =>
              option.namalengkap
                ? `${option.namalengkap} - ${option.jabatan}`
                : ''
            }
            options={users}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Approver"
                value={actionHeader?.approverDisplayName}
              />
            )}
            getOptionSelected={(option, value) =>
              option.namalengkap === value.namalengkap
            }
            defaultValue={{
              namalengkap: actionHeader?.approverDisplayName,
              jabatan: actionHeader?.approverJabatan,
            }}
            disabled={
              (actionHeader?.id &&
                actionHeader.statusHeaderName === 'Completed') ||
              actionHeader?.statusHeaderName === 'Closed'
            }
          />
        </FormControl>
      </Grid>
      {isAuto && props.onModal ? (
        <Grid item xs={12} marginBottom={2}>
          <Button variant="contained" color="primary" onClick={handleSetHeader}>
            Set Header
          </Button>
        </Grid>
      ) : (
        ''
      )}
    </Grid>
  );
};

export default ActionHeader;
